import axios from "axios";
import store from "../store";

class Files {

    upload(file)
    {
        let jwt = store.state.jwt;

        var formdata = new FormData();

        formdata.set(file.name, file);

        console.log(formdata)

        return new Promise(function (resolve, reject) {
			axios
				.post(
					`${process.env.VUE_APP_SAAS_BACK}` + "/files",
					formdata,
					{
						headers: { Authorization: "Bearer " + jwt },
					}
				)
				.then(function (response) {
					resolve(response.data);
				})
				.catch(function (error) {
					reject(error);
				});
		})      
    }

}

export default new Files();
